import React from "react";
import {CONVERSIONAL_ORANGE, Spinner} from "conversional-spinner";

export default () => {
  return <div
    style={{height: 500, width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <Spinner size={"large"} color={CONVERSIONAL_ORANGE}/>
  </div>
}
